
import { Share2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export const JournalEmptyState = () => {
  return (
    <Card className="bg-background shadow-sm border-muted">
      <CardContent className="flex flex-col items-center justify-center py-12 text-center">
        <div className="rounded-full bg-muted/30 p-6 mb-4">
          <Share2 className="h-8 w-8 text-muted-foreground" />
        </div>
        <h3 className="text-xl font-medium mb-2">Aucune entrée de journal</h3>
        <p className="text-sm text-muted-foreground max-w-md">
          Commencez à noter vos observations quotidiennes pour suivre votre santé et avoir un historique complet.
        </p>
      </CardContent>
    </Card>
  );
};
